<template>
  <b-row>
    <b-col cols="12">
      <b-tabs content-class="mt-3">
        <b-tab title="Field Label" active>
          <b-tabs pills card vertical>
            <!-- Render Tabs, supply a unique `key` to each tab -->
            <b-tab
              @click="tabClick(data)"
              v-for="(data, index) in form.formTranslations"
              :key="index"
              :title="data"
            >
              <!-- translation form wrappe -->
              <div>
                <b-form-group label="Field Label">
                  <b-form-input @blur="addLanguageToField(data)" v-model="label" type="text"></b-form-input>
                </b-form-group>
              </div>
            </b-tab>
          </b-tabs>
        </b-tab>

        <!-- Titel And helpertext -->

        <b-tab title="Text">
          <b-tabs pills card vertical>
            <!-- Render Tabs, supply a unique `key` to each tab -->
            <b-tab
              @click="tabClick(data)"
              v-for="(data, index) in form.formTranslations"
              :key="index"
              :title="data"
            >
              <!-- translation form wrappe -->
              <div>
                <b-form-group label="Title">
                  <b-form-input @blur="addLanguageToField(data)" v-model="title"></b-form-input>
                </b-form-group>

                <b-form-group label="Description">
                  <b-form-textarea v-model="description"></b-form-textarea>
                </b-form-group>
              </div>
            </b-tab>
          </b-tabs>
        </b-tab>

        <!-- Items tabb -->
        <b-tab title="Add Items">
          <!-- Add Items tab -->
          <b-tabs pills card vertical>
            <b-tab
              @click="tabClick(language)"
              v-for="(language, index) in form.formTranslations"
              :key="index"
              :title="language"
            >
              <b-form @submit.stop.prevent class="active text-left mt-2">
                <table class="table table-sm">
                  <thead>
                    <tr class="text-center">
                      <th>Item text</th>
                      <th>Item Value</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in fieldData.items" :key="index">
                      <td>
                        <b-form-input
                          :value="item.message[transalationLanguage]"
                          @input="setFieldItemsText($event, index)"
                          @focus="$event.target.select()"
                        ></b-form-input>
                      </td>
                      <td>
                        <b-form-input
                          :disabled="transalationLanguage !== 'english'"
                          :value="item.value"
                          @input="setFieldItemsValue($event, index)"
                          @focus="$event.target.select()"
                        ></b-form-input>
                      </td>
                      <td>
                        <b-button
                          variant="outline-danger"
                          v-if="index > 0"
                          class="btn btn-outline-danger btn-sm"
                          @click="onDeleteOption(index)"
                        >
                          <i class="fa fa-trash"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <b-button variant="primary" @click="addItems">
                  <i class="fa fa-plus"></i>
                </b-button>
                <br />
              </b-form>
            </b-tab>
          </b-tabs>
        </b-tab>
        <b-tab title="List Type">
          <b-form-radio-group
            id="radio-group-1"
            v-model="selectedListType"
            :options="options"
            name="radio-options"
          ></b-form-radio-group>
        </b-tab>
        <b-tab title="List Style" v-if="fieldData.selectedListType === 1">
          <b-form-radio-group
            v-model="selectedListStyle"
            :options="styleOptions"
            name="radio-options"
          ></b-form-radio-group>
        </b-tab>
      </b-tabs>
    </b-col>
    <!-- End of column -->
  </b-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import { Helper } from "../helpers";
import { EventBus } from "@/event-bus.js";
export default {
  name: "AdvanceHeadingSettings",
  components: {},
  data() {
    return {
      title: null,
      description: null,
      selectedListType: 1,
      options: [
        { text: "Unorder List", value: 1 },
        { text: "Order List", value: 2 }
      ],
      selectedListStyle: "text-left",
      styleOptions: [
        { text: "Number", value: "a" },
        { text: "Alpha", value: "b" },
        { text: "Circle", value: "c" },
        { text: "Square", value: "d" }
      ],
      itemName: undefined,
      itemValue: undefined,

      transalationLanguage: "english",

      label: undefined,

      isLoading: false
    };
  },
  created() {
    EventBus.$on("onSaveSettings", value => {
      this.setAdvanceSettingsForSelect();
      this.addLanguageToField(this.transalationLanguage);
    });
  },
  mounted() {
    (this.selectedListType = this.fieldData.selectedListType),
      (this.selectedListStyle = this.fieldData.selectedListStyle),
      (this.label = this.fieldData.label[this.transalationLanguage]);
    this.title = this.fieldData.title[this.transalationLanguage];
    this.description = this.fieldData.description[this.transalationLanguage];
  },
  computed: {
    ...mapGetters({
      form: "form1"
    })
  },
  methods: {
    ...mapActions(["updateField"]),

    tabClick(key) {
      this.transalationLanguage = key.toLowerCase();
      this.label = this.fieldData.label[this.transalationLanguage];
      this.title = this.fieldData.title[this.transalationLanguage];
      this.description = this.fieldData.description[this.transalationLanguage];
    },

    addLanguageToField(language) {
      let tempKey = language.toLowerCase();
      this.fieldData.label[tempKey] = this.label;
      this.fieldData.title[tempKey] = this.title;
      this.fieldData.description[tempKey] = this.description;

      // Helper.makeToast(this.$bvToast, "success", "Language Update");
    },

    //methods for radio items settings
    setFieldItemsValue(value, index) {
      this.fieldData.items[index].value;
      this.itemValue = value;
      this.fieldData.items[index].value = value;
    },

    setFieldItemsText(value, index) {
      // this.form.formTitle[this.translationLanguage] = value;
      this.itemName = value;
      this.fieldData.items[index].message[this.transalationLanguage] = value;
    },

    addItems() {
      // let setName = this.fieldData.inputType === 'radio' ? 'Radio' : this.fieldData.inputType === 'checkbox' ? 'Checkbox' :
      let newItem = {
        value: this.itemValue
          ? this.itemValue
          : this.fieldData.inputType +
            " value" +
            this.fieldData.items.length +
            1,
        message: {
          english: this.itemName
            ? this.itemName
            : this.fieldData.inputType +
              " message " +
              this.fieldData.items.length +
              1
        }
      };

      // // console.log("newItem", newItem)
      this.fieldData.items.push(newItem);
    },

    onDeleteOption(index) {
      if (this.fieldData.items.length > 1) {
        this.fieldData.items.splice(this.fieldData.items.indexOf(index), 1);
      }
    },

    setAdvanceSettingsForSelect() {
      this.fieldData.selectedListType = this.selectedListType;
      this.fieldData.selectedListStyle = this.selectedListStyle;
    }
  },
  props: {
    fieldData: Object,
    sectionIndex: Number,
    fieldIndex: Number
  }
};
</script>

<style>
.cursor {
  cursor: pointer;
}
</style>
